// jQuery
import $ from 'jquery'
window.$ = $

// Owls carousel
import 'owl.carousel'

// TypeIT
import TypeIt from 'typeit'

/**
 * Tag line typing
 */
var tageLineAndMessagesTyping = function () {
  new TypeIt('#tagLine', {
    strings: ['Make Your Customer Happy!'],
    speed: 50,
    deleteSpeed: 50,
    autoStart: true,
    startDelay: 500,
    cursorChar: '_',
    cursorSpeed: 1000,
    afterComplete: function (tageLineTyping) {
      tageLineTyping.destroy()
      new TypeIt('#keyMessage', {
        speed: 30,
        deleteSpeed: 50,
        autoStart: true,
        startDelay: 200,
        cursorChar: '_',
        cursorSpeed: 1000,
        afterComplete: function (keyMessagesTyping) {
          keyMessagesTyping.destroy()
          setTimeout(function () {
            $('#tagLine').html('')
            $('#keyMessage').html('')
            tageLineAndMessagesTyping()
          }, 10000)
        }
      })
        .type('<span>Tạo dựng giá trị hạnh phúc cho khách hàng </span>')
        .type('<br class="hidden md:inline" />')
        .type('<span>bằng trải nghiệm tuyệt vời từ sự thấu hiểu sâu sắc </span>')
        .type('<br class="hidden md:inline" />')
        .type('<span>giúp chuyển hoá khách hàng thành người đồng hành </span>')
        .type('<br class="hidden md:inline" />')
        .type('<span>cùng doanh nghiệp trên con đường kiến tạo và phát triển.</span>')
        .go()
    }
  }).go()
}

/**
 * On Scrolling handler
 */
var onScrollHandler = function () {
  var scrollTop = $(window).scrollTop()
  if (scrollTop > 10 && !$('#headerBar').hasClass('fixed-header')) {
    $('#headerBar').addClass('fixed-header')
  } else if (scrollTop <= 10 && $('#headerBar').hasClass('fixed-header')) {
    $('#headerBar').removeClass('fixed-header')
  }
}

/**
 * On click menu item handler
 *
 * @param id
 */
var onClickMenuItemHandler = function (id) {
  var box = $(`#${id}`)
  if (box) {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: box.offset().top - 80
      },
      1000
    )
  }
}

/**
 * Ready
 */
$(function () {
  console.log(system)

  // Check scroll
  onScrollHandler()

  // Tage line typing
  if ($('#tagLine') && $('#keyMessage')) {
    tageLineAndMessagesTyping()
  }

  // Fixed header on scroll
  $(window).scroll(onScrollHandler)

  // Menu clicking
  $('#introMenuItem').click(function () {
    onClickMenuItemHandler('introBox')
  })
  $('#solutionMenuItem').click(function () {
    onClickMenuItemHandler('solutionBox')
  })
  $('#consultantMenuItem').click(function () {
    onClickMenuItemHandler('consultantBox')
  })
  $('#contactMenuItem').click(function () {
    onClickMenuItemHandler('contactBox')
  })
})
